import { render, staticRenderFns } from "./CertificadoView.vue?vue&type=template&id=a5bc170a&"
import script from "./CertificadoView.vue?vue&type=script&lang=js&"
export * from "./CertificadoView.vue?vue&type=script&lang=js&"
import style0 from "./CertificadoView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports